import { Spacing } from '@doordash/design-language';
export var ARROW_SIZE = 6;
export var SPACING_FROM_NEAREST_CORNER = Spacing.XSmall;
export var SPACING_FROM_ANCHOR = Spacing.XxSmall;
export var InteractionTypes = {
  ToggleClick: 'TOGGLE_CLICK',
  Controlled: 'CONTROLLED'
};
export var ContentWrapperDisplayModes = {
  Flex: 'flex',
  InlineFlex: 'inline-flex',
  InlineBlock: 'inline-block',
  Block: 'block',
  Inline: 'inline'
};